import { cloneDeep } from '@apollo/client/utilities';
import { CompanyEntity } from './common/entity';
import { TriggerEntityType } from './trigger';
import { ProductTransaction } from './productTransaction';
import { StockLocationAggregateType } from './common/stockLocationAggregateType';

export class Alert extends CompanyEntity {
  entityType!: TriggerEntityType;
  entityValue!: string;
  triggeredValue!: string;
  triggerId!: string;
  stockLocationAggregateType!: StockLocationAggregateType;
  stockLocationIds: string[] = [];
  triggeredStockLocation?: string;
  userId!: string;
  customFieldIds: string[] = [];
  alertString!: string;
  productTransaction?: ProductTransaction;
  triggerStateId?: string;
  processed: boolean = false;

  forUpdate() {
    throw new Error('Method not implemented.');
  }

  forDelete() {
    throw new Error('Method not implemented.');
  }

  validate(fields: any[]) {
    throw new Error('Method not implemented.');
  }

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, cloneDeep(obj));
    if (!obj.customFieldIds) this.customFieldIds = [];
    if (this.productTransaction) this.productTransaction = new ProductTransaction(this.productTransaction);
  }
}
